import { render } from "./Author.vue?vue&type=template&id=1470725c&scoped=true"
import script from "./Author.vue?vue&type=script&lang=js"
export * from "./Author.vue?vue&type=script&lang=js"

import "./Author.vue?vue&type=style&index=0&id=1470725c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1470725c"

export default script